import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import jerm from "../../assets/jerm.svg";
import "./Login.scss";
import DropDown from "../../components/DropDown";
import { useTranslation } from "../../contexts/TranslationContext";
import { loginUser, getAdminUser } from "../../api/apiServiceFetch";
import { useAuth } from "../../contexts/auth";

const generateCaptcha = () => {
	const num1 = Math.floor(Math.random() * 10);
	const num2 = Math.floor(Math.random() * 10);
	return {
		question: `${num1} + ${num2} = ?`,
		answer: num1 + num2,
	};
};

const Login = () => {
	const navigate = useNavigate();
	const { setUserBase } = useAuth();
	const { t, changeLanguage, languageOptions, language } = useTranslation();
	const [formData, setFormData] = useState({
		username: "",
		password: "",
		captcha: "",
	});
	const [isUsernameEmpty, setIsUsernameEmpty] = useState(false);
	const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
	// const [captcha, setCaptcha] = useState(generateCaptcha());
	const [isCaptchaIncorrect, setIsCaptchaIncorrect] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showPassword, setShowPassword] = useState(false);

	// const handleChangeLanguage = (e) => {
	//     changeLanguage(e.value);
	// };

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};

	// const handleNumericInputChange = (e) => {
	//     const { name, value } = e.target;
	//     const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters
	//     setFormData({
	//         ...formData,
	//         [name]: numericValue
	//     });
	// };

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if the fields are empty
		const isUsernameEmptyCheck = formData.username.trim() === "";
		const isPasswordEmptyCheck = formData.password.trim() === "";

		setIsUsernameEmpty(isUsernameEmptyCheck);
		setIsPasswordEmpty(isPasswordEmptyCheck);

		if (!isUsernameEmptyCheck && !isPasswordEmptyCheck) {
			// if (parseInt(formData.captcha, 10) === captcha.answer) {

			// setIsCaptchaIncorrect(false);
			try {
				const loginResponse = await loginUser(formData);
				if (loginResponse.isSuccess) {
					// Tokens are stored by loginUser; load the profile so App switches to Content without a manual refresh.
					const user = await getAdminUser();
					setUserBase(user);
					navigate("/");
				} else {
					// setCaptcha(generateCaptcha());
					setErrorMessage("Неверные данные входа");
				}
			} catch (error) {
				setErrorMessage("Ошибка сервера");
			}
			// } else {
			//     // setIsCaptchaIncorrect(true);
			//     //setCaptcha(generateCaptcha());
			//     setFormData({
			//         ...formData,
			//         captcha: ''
			//     });
			// }
		}
	};

	return (
		<div className="container">
			<div className="login-container">
				<div className="login_header">
					{/* <DropDown data={languageOptions} placeholder="Select language" value={language} onChange={handleChangeLanguage} /> */}
					<img src={jerm} alt="Logo" className="logo" />
				</div>
				<form className="login-form" onSubmit={handleSubmit}>
					<div className={`form-group ${isUsernameEmpty ? "reqLabel" : ""}`}>
						<label
							htmlFor="username"
							className={`${isUsernameEmpty ? "reqLabel" : ""}`}
						>
							Логин{isUsernameEmpty ? " *" : ""}
						</label>
						<input
							type="text"
							id="username"
							name="username"
							value={formData.username}
							placeholder="Логин"
							onChange={handleInputChange}
							onFocus={() => setIsUsernameEmpty(false)}
							className={isUsernameEmpty ? "reqInput" : ""}
						/>
					</div>
					<div className={`form-group ${isPasswordEmpty ? "reqLabel" : ""}`}>
						<label
							htmlFor="password"
							className={`${isPasswordEmpty ? "reqLabel" : ""}`}
						>
							Пароль{isPasswordEmpty ? " *" : ""}
						</label>
						<div className="password-field">
							<input
								type={showPassword ? "text" : "password"}
								id="password"
								name="password"
								value={formData.password}
								placeholder="Пароль"
								onChange={handleInputChange}
								onFocus={() => setIsPasswordEmpty(false)}
								className={isPasswordEmpty ? "reqInput" : ""}
							/>
							<button
								type="button"
								className="toggle-password"
								onClick={() => setShowPassword((v) => !v)}
								aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
							>
								{showPassword ? (
									<svg
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
										<path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
										<line x1="1" y1="1" x2="23" y2="23" />
										<path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
									</svg>
								) : (
									<svg
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
										<circle cx="12" cy="12" r="3" />
									</svg>
								)}
							</button>
						</div>
					</div>
					{/* <div className="form-group center">
                        <label htmlFor="captcha">{t('enterTheAnswer')}</label>
                        <div className='captcha'>
                            <label htmlFor="captcha">{captcha.question}</label>
                            <input
                                type="text"
                                id="captcha"
                                name="captcha"
                                autoComplete="off"
                                value={formData.captcha}
                                placeholder="XX"
                                onChange={handleNumericInputChange} // Use numeric input handler
                                maxLength={2}
                                className={isCaptchaIncorrect ? 'reqInput' : ''}
                            />
                        </div>
                        {isCaptchaIncorrect && <span className='reqLabel'>{t('incorrectAnswer')}</span>}
                    </div> */}
					{errorMessage && <div className="error-message">{errorMessage}</div>}
					<button type="submit">Войти</button>
				</form>
			</div>
		</div>
	);
};

export default Login;
